module.exports = __webpack_public_path__ + "static/media/background-leaf.2d9c4d2c.svg";